module.exports = __webpack_public_path__ + "static/media/whyDonate.3c5d02b3.png";